<script>
    import { fade } from 'svelte/transition';

    let iForm;

    let loaded = false;

    function onLoad() {
        loaded = true
    }

</script>

<div class="download-page-container">
    <div class="customer-journey-diagram">
        <img src="images/ACJ-ebook-thumbnail.png" class="download-image" alt="Download our ebook">
    </div>
    <div class="download-page-column">
        <div>
            <h1 class="download-page-header">Discover more</h1>
            <div class="download-page-introduction">
                <p>Explore how thought leadership can get you on your buyer’s radar and help influence their decisions.</p>
                <p>Enter your details below to download our digital guide to accelerating your customer’s journey.</p>
            </div>
        </div>
    </div>
</div>

{#if !loaded}
    <h3 in:fade class="loading">Loading form...</h3>
{/if}

<iframe
    bind:this={iForm}
    on:load={() => onLoad()}
    title="Read guide form"
    src="https://insight.longitude.co.uk/l/596911/2022-06-15/2vmdsnd"
    width="100%" height="700" type="text/html"
    frameborder="0" allowTransparency="true" style="border: 0; margin: -16px; background-color: black"
></iframe>


<style>
    .loading {
        text-align: center;
        color: white;
        height: 0;
        overflow: visible;
        margin: 0;
    }

    .download-image {
        width: 100%;
    }

    @media screen and (min-width: 640px) {
        .download-image {
            width: 100%;
            transform: translateY(40px);
        }
    }

    .download-page-column {
        max-width: 335px;
    }

    .download-page-header {
        color: #f5d2b5;
        font-weight: 500;
        font-size: 38px;
        margin-bottom: 35px;
    }

    .download-page-introduction {
        font-size: 23px;
        color: white;
    }

    .customer-journey-diagram {
        margin-top: 25px;
    }

    @media (min-width: 640px) {

        .download-page-column {
            margin-left: 40px;
            position: relative;
        }

        .download-page-header {
            margin-bottom: 57px;
        }

        .customer-journey-diagram {
            height: 335px;
            margin-top: 0;
        }
    }

    .download-page-container {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
    }

    @media (min-width: 640px) {
        .download-page-container {
            width: 100%;
            flex-direction: row;
        }

        .download-page-container > * {
            width: 50%;
        }
    }
</style>
